export const GET_GLOBAL_DESTINATION_SERVICES_FAILURE = 'GET_GLOBAL_DESTINATION_SERVICES_FAILURE';
export const GET_GLOBAL_DESTINATION_SERVICES_REQUEST = 'GET_GLOBAL_DESTINATION_SERVICES_REQUEST';
export const GET_GLOBAL_DESTINATION_SERVICES_SUCCESS = 'GET_GLOBAL_DESTINATION_SERVICES_SUCCESS';

export const POST_GLOBAL_DESTINATION_SERVICES_FAILURE = 'POST_GLOBAL_DESTINATION_SERVICES_FAILURE';
export const POST_GLOBAL_DESTINATION_SERVICES_REQUEST = 'POST_GLOBAL_DESTINATION_SERVICES_REQUEST';
export const POST_GLOBAL_DESTINATION_SERVICES_SUCCESS = 'POST_GLOBAL_DESTINATION_SERVICES_SUCCESS';

export const UPDATE_GLOBAL_DESTINATION_SERVICES_FAILURE = 'UPDATE_GLOBAL_DESTINATION_SERVICES_FAILURE';
export const UPDATE_GLOBAL_DESTINATION_SERVICES_REQUEST = 'UPDATE_GLOBAL_DESTINATION_SERVICES_REQUEST';
export const UPDATE_GLOBAL_DESTINATION_SERVICES_SUCCESS = 'UPDATE_GLOBAL_DESTINATION_SERVICES_SUCCESS';

export const DELETE_GLOBAL_DESTINATION_SERVICES_FAILURE = 'DELETE_GLOBAL_DESTINATION_SERVICES_FAILURE';
export const DELETE_GLOBAL_DESTINATION_SERVICES_REQUEST = 'DELETE_GLOBAL_DESTINATION_SERVICES_REQUEST';
export const DELETE_GLOBAL_DESTINATION_SERVICES_SUCCESS = 'DELETE_GLOBAL_DESTINATION_SERVICES_SUCCESS';

export const GET_GLOBAL_LANGUAGE_TRAINING_FAILURE = 'GET_GLOBAL_LANGUAGE_TRAINING_FAILURE';
export const GET_GLOBAL_LANGUAGE_TRAINING_REQUEST = 'GET_GLOBAL_LANGUAGE_TRAINING_REQUEST';
export const GET_GLOBAL_LANGUAGE_TRAINING_SUCCESS = 'GET_GLOBAL_LANGUAGE_TRAINING_SUCCESS';

export const POST_GLOBAL_LANGUAGE_TRAINING_FAILURE = 'POST_GLOBAL_LANGUAGE_TRAINING_FAILURE';
export const POST_GLOBAL_LANGUAGE_TRAINING_REQUEST = 'POST_GLOBAL_LANGUAGE_TRAINING_REQUEST';
export const POST_GLOBAL_LANGUAGE_TRAINING_SUCCESS = 'POST_GLOBAL_LANGUAGE_TRAINING_SUCCESS';

export const UPDATE_GLOBAL_LANGUAGE_TRAINING_FAILURE = 'UPDATE_GLOBAL_LANGUAGE_TRAINING_FAILURE';
export const UPDATE_GLOBAL_LANGUAGE_TRAINING_REQUEST = 'UPDATE_GLOBAL_LANGUAGE_TRAINING_REQUEST';
export const UPDATE_GLOBAL_LANGUAGE_TRAINING_SUCCESS = 'UPDATE_GLOBAL_LANGUAGE_TRAINING_SUCCESS';

export const DELETE_GLOBAL_LANGUAGE_TRAINING_FAILURE = 'DELETE_GLOBAL_LANGUAGE_TRAINING_FAILURE';
export const DELETE_GLOBAL_LANGUAGE_TRAINING_REQUEST = 'DELETE_GLOBAL_LANGUAGE_TRAINING_REQUEST';
export const DELETE_GLOBAL_LANGUAGE_TRAINING_SUCCESS = 'DELETE_GLOBAL_LANGUAGE_TRAINING_SUCCESS';

export const GET_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE = 'GET_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE';
export const GET_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST = 'GET_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST';
export const GET_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS = 'GET_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS';

export const POST_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE = 'POST_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE';
export const POST_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST = 'POST_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST';
export const POST_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS = 'POST_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS';

export const UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE = 'UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE';
export const UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST = 'UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST';
export const UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS = 'UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS';

export const DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE = 'DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE';
export const DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST = 'DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST';
export const DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS = 'DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS';

export const GET_GLOBAL_INFO_FAILURE = 'GET_GLOBAL_INFO_FAILURE';
export const GET_GLOBAL_INFO_REQUEST = 'GET_GLOBAL_INFO_REQUEST';
export const GET_GLOBAL_INFO_SUCCESS = 'GET_GLOBAL_INFO_SUCCESS';

export const POST_GLOBAL_INFO_FAILURE = 'POST_GLOBAL_INFO_FAILURE';
export const POST_GLOBAL_INFO_REQUEST = 'POST_GLOBAL_INFO_REQUEST';
export const POST_GLOBAL_INFO_SUCCESS = 'POST_GLOBAL_INFO_SUCCESS';

export const UPDATE_GLOBAL_INFO_FAILURE = 'UPDATE_GLOBAL_INFO_FAILURE';
export const UPDATE_GLOBAL_INFO_REQUEST = 'UPDATE_GLOBAL_INFO_REQUEST';
export const UPDATE_GLOBAL_INFO_SUCCESS = 'UPDATE_GLOBAL_INFO_SUCCESS';

export const GET_ASSIGNMENT_TRIPS_FAILURE = 'GET_ASSIGNMENT_TRIPS_FAILURE';
export const GET_ASSIGNMENT_TRIPS_REQUEST = 'GET_ASSIGNMENT_TRIPS_REQUEST';
export const GET_ASSIGNMENT_TRIPS_SUCCESS = 'GET_ASSIGNMENT_TRIPS_SUCCESS';

export const GET_ASSIGNMENT_TRIP_FAILURE = 'GET_ASSIGNMENT_TRIPS_FAILURE';
export const GET_ASSIGNMENT_TRIP_REQUEST = 'GET_ASSIGNMENT_TRIP_REQUEST';
export const GET_ASSIGNMENT_TRIP_SUCCESS = 'GET_ASSIGNMENT_TRIP_SUCCESS';

export const UPSERT_ASSIGNMENT_TRIPS_FAILURE = 'UPSERT_ASSIGNMENT_TRIPS_FAILURE';
export const UPSERT_ASSIGNMENT_TRIPS_REQUEST = 'UPSERT_ASSIGNMENT_TRIPS_REQUEST';
export const UPSERT_ASSIGNMENT_TRIPS_SUCCESS = 'UPSERT_ASSIGNMENT_TRIPS_SUCCESS';

export const DELETE_ASSIGNMENT_TRIPS_FAILURE = 'DELETE_ASSIGNMENT_TRIPS_FAILURE';
export const DELETE_ASSIGNMENT_TRIPS_REQUEST = 'DELETE_ASSIGNMENT_TRIPS_REQUEST';
export const DELETE_ASSIGNMENT_TRIPS_SUCCESS = 'DELETE_ASSIGNMENT_TRIPS_SUCCESS';

export const GET_ASSIGNMENT_EXTENSIONS_FAILURE = 'GET_ASSIGNMENT_EXTENSIONS_FAILURE';
export const GET_ASSIGNMENT_EXTENSIONS_REQUEST = 'GET_ASSIGNMENT_EXTENSIONS_REQUEST';
export const GET_ASSIGNMENT_EXTENSIONS_SUCCESS = 'GET_ASSIGNMENT_EXTENSIONS_SUCCESS';

export const POST_ASSIGNMENT_EXTENSIONS_FAILURE = 'POST_ASSIGNMENT_EXTENSIONS_FAILURE';
export const POST_ASSIGNMENT_EXTENSIONS_REQUEST = 'POST_ASSIGNMENT_EXTENSIONS_REQUEST';
export const POST_ASSIGNMENT_EXTENSIONS_SUCCESS = 'POST_ASSIGNMENT_EXTENSIONS_SUCCESS';

export const UPDATE_ASSIGNMENT_EXTENSIONS_FAILURE = 'UPDATE_ASSIGNMENT_EXTENSIONS_FAILURE';
export const UPDATE_ASSIGNMENT_EXTENSIONS_REQUEST = 'UPDATE_ASSIGNMENT_EXTENSIONS_REQUEST';
export const UPDATE_ASSIGNMENT_EXTENSIONS_SUCCESS = 'UPDATE_ASSIGNMENT_EXTENSIONS_SUCCESS';

export const DELETE_ASSIGNMENT_EXTENSIONS_FAILURE = 'DELETE_ASSIGNMENT_EXTENSIONS_FAILURE';
export const DELETE_ASSIGNMENT_EXTENSIONS_REQUEST = 'DELETE_ASSIGNMENT_EXTENSIONS_REQUEST';
export const DELETE_ASSIGNMENT_EXTENSIONS_SUCCESS = 'DELETE_ASSIGNMENT_EXTENSIONS_SUCCESS';

export const GET_GLOBAL_ASSIGNMENT_FAILURE = 'GET_GLOBAL_ASSIGNMENT_FAILURE';
export const GET_GLOBAL_ASSIGNMENT_REQUEST = 'GET_GLOBAL_ASSIGNMENT_REQUEST';
export const GET_GLOBAL_ASSIGNMENT_SUCCESS = 'GET_GLOBAL_ASSIGNMENT_SUCCESS';

export const POST_GLOBAL_ASSIGNMENT_REQUEST = 'POST_GLOBAL_ASSIGNMENT_REQUEST';
export const POST_GLOBAL_ASSIGNMENT_FAILURE = 'POST_GLOBAL_ASSIGNMENT_FAILURE';
export const POST_GLOBAL_ASSIGNMENT_SUCCESS = 'POST_GLOBAL_ASSIGNMENT_SUCCESS';

export const UPDATE_GLOBAL_ASSIGNMENT_REQUEST = 'UPDATE_GLOBAL_ASSIGNMENT_REQUEST';
export const UPDATE_GLOBAL_ASSIGNMENT_FAILURE = 'UPDATE_GLOBAL_ASSIGNMENT_FAILURE';
export const UPDATE_GLOBAL_ASSIGNMENT_SUCCESS = 'UPDATE_GLOBAL_ASSIGNMENT_SUCCESS';

export const GET_GLOBAL_PROPERTY_MANAGEMENT_FAILURE = 'GET_GLOBAL_PROPERTY_MANAGEMENT_FAILURE';
export const GET_GLOBAL_PROPERTY_MANAGEMENT_REQUEST = 'GET_GLOBAL_PROPERTY_MANAGEMENT_REQUEST';
export const GET_GLOBAL_PROPERTY_MANAGEMENT_SUCCESS = 'GET_GLOBAL_PROPERTY_MANAGEMENT_SUCCESS';

export const PUT_GLOBAL_PROPERTY_MANAGEMENT_HOST_FAILURE = 'PUT_GLOBAL_PROPERTY_MANAGEMENT_HOST_FAILURE';
export const PUT_GLOBAL_PROPERTY_MANAGEMENT_HOST_REQUEST = 'PUT_GLOBAL_PROPERTY_MANAGEMENT_HOST_REQUEST';
export const PUT_GLOBAL_PROPERTY_MANAGEMENT_HOST_SUCCESS = 'PUT_GLOBAL_PROPERTY_MANAGEMENT_HOST_SUCCESS';

export const POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_FAILURE = 'POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_FAILURE';
export const POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_REQUEST = 'POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_REQUEST';
export const POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS = 'POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS';

export const PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_FAILURE = 'PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_FAILURE';
export const PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_REQUEST = 'PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_REQUEST';
export const PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS = 'PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS';

export const DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_FAILURE = 'DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_FAILURE';
export const DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_REQUEST = 'DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_REQUEST';
export const DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS = 'DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS';

export const POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_FAILURE = 'POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_FAILURE';
export const POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_REQUEST = 'POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_REQUEST';
export const POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS = 'POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS';

export const PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_FAILURE = 'PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_FAILURE';
export const PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_REQUEST = 'PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_REQUEST';
export const PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS = 'PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS';

export const DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_FAILURE = 'DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_FAILURE';
export const DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_REQUEST = 'DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_REQUEST';
export const DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS = 'DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS';

export const PUT_GLOBAL_VISA_VACCINE_FAILURE = 'PUT_GLOBAL_VISA_VACCINE_FAILURE';
export const PUT_GLOBAL_VISA_VACCINE_REQUEST = 'PUT_GLOBAL_VISA_VACCINE_REQUEST';
export const PUT_GLOBAL_VISA_VACCINE_SUCCESS = 'PUT_GLOBAL_VISA_VACCINE_SUCCESS';
